import { render, staticRenderFns } from "./EditUsuarioYPermisos.vue?vue&type=template&id=5d302a9a&scoped=true"
import script from "./EditUsuarioYPermisos.vue?vue&type=script&lang=js"
export * from "./EditUsuarioYPermisos.vue?vue&type=script&lang=js"
import style0 from "./EditUsuarioYPermisos.vue?vue&type=style&index=0&id=5d302a9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d302a9a",
  null
  
)

export default component.exports